import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { applicationPaths, localStorageKeys, screenDetails } from '../../../../Models/configurations';
import { progressStepNames } from '../../../../Models/progress-bar-step';
import { AppsettingService } from '../../../../Services/appsetting.service';
import { SecureStorageService } from './../../../../Services/secure-storage.service';
import { UtilityServices } from './../../../../Services/utility.services';
import { TranslateService } from '@ngx-translate/core';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { CultureLocaleService } from 'projects/Check-In/src/app/Services/culture-locale.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';

@Component({
  selector: 'app-second-step',
  templateUrl: './second-step.component.html',
  styleUrls: ['./second-step.component.css']
})
export class SecondStepComponent implements OnInit {
  urlName: string;
  ownerVerificationdetails: FormGroup;
  IsSubmitted = false;
  customerDetail: any;
  countryPhoneCode: string;
  countnryDetail: any;
  isOwner:boolean=false;
  isPlanningAvailable:boolean=false;
  checkInNotAllowed:any;
  dealerDetails:any;
  CountryISO = CountryISO;
  public steps: any;
  public activeStepName: string;
  public activeStepCompleted: boolean;
  ng2TelInputObject: any;
  userInputMobilecode?: string = '';
  selectedCountryISO = this.cultureLocaleService.getLocale() || CountryISO.Norway;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly utilityService: UtilityServices,
    private readonly secureStorageService: SecureStorageService,
    private readonly appsettingService: AppsettingService,
    private readonly cdrf: ChangeDetectorRef,
    private readonly translate: TranslateService,
    private readonly cultureLocaleService: CultureLocaleService
  ) {
    this.urlName = '/' + applicationPaths.fourth;
    if (this.secureStorageService.getKeyData(localStorageKeys.stepStatus) !== undefined) {
      this.steps = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
    }
    this.isOwner = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).isOwner
  }

      
  ngOnInit(): void {
    this.onlyCountries = Constant.OnlyCountry;
    this.countryDialCodes= Constant.CountryDialCodes;
    this.ownerVerificationValidation();
    this.verificationDetails();
    this.getCheckInNotAllowed();
    this.onlyCountries = Constant.OnlyCountry;
  }

  getCheckInNotAllowed() {
    this.isPlanningAvailable = this.secureStorageService.getKeyData(localStorageKeys.isPlanningAvailable);
    if (!this.isPlanningAvailable) {
      this.checkInNotAllowed = '';
      this.dealerDetails = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).dealerDetail;
      this.checkInNotAllowed = this.translate.instant("lblCheckInNotAllowed");
      this.checkInNotAllowed = this.checkInNotAllowed.replace("{DealerPhoneNumber}", this.dealerDetails.mobileNumber);
      return this.checkInNotAllowed;
    }
  }

  public ownerVerificationFormSubmit() {
    this.IsSubmitted = true;
    this.mobileNumberChanged();
    this.secureStorageService.setKeyData(localStorageKeys.nomineeContactDetails,  this.ownerVerificationdetails.getRawValue());
    this.secureStorageService.setKeyData(localStorageKeys.ownerDetails,  this.ownerVerificationdetails.getRawValue());
    this.activeStepCompleted = true;
    this.appsettingService.IsBackBtnBackFlag=true;
    this.activeStepName = progressStepNames.stepName1;
    this.appsettingService.stepCompletion(this.activeStepName, this.activeStepCompleted);
    this.steps = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
    this.cdrf.detectChanges();
    this.moveNext();
  }


  public moveNext(): void {     
    this.urlName = this.appsettingService.getScreenConfiguration(screenDetails.stepTwo);
    this.utilityService.navigateToNext(this.urlName);
  }


  get f() { return this.ownerVerificationdetails.controls; }

  public ownerVerificationValidation() {
    this.ownerVerificationdetails = this.formBuilder.group({
      email: new FormControl({value:'',disabled: this.isOwner}, [Validators.required, Validators.email,Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)]),
      phoneNumber: new FormControl({value:'',disabled: this.isOwner}),
      ownerTerms: new FormControl(false),
      countryPhoneCode: new FormControl({value:null,disabled: this.isOwner}),
      name: new FormControl({value:'',disabled: this.isOwner},[Validators.required]),
      city: new FormControl({value:'',disabled: this.isOwner},[Validators.required]),
      country: new FormControl({value:'',disabled: this.isOwner},[Validators.required]),
      address1:new FormControl({value:'',disabled: this.isOwner},[Validators.required]),
      address2:new FormControl({value:'',disabled: this.isOwner}),
      postcode: new FormControl({value:'',disabled: this.isOwner},[Validators.required,Validators.pattern(/^[a-zA-Z0-9]*$/)]),
    }, {
      
    });
    
  }

  public verificationDetails(): void {
    this.customerDetail = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).customerDetail;
    this.setOwernVerifcationValue();
  }

  private setOwernVerifcationValue() {
    if (this.secureStorageService.getKeyData(localStorageKeys.ownerDetails) !== undefined && this.appsettingService.IsBackBtnBackFlag) {
      this.ownerVerificationdetails.controls.email.setValue(this.secureStorageService.getKeyData(localStorageKeys.ownerDetails).email);
      this.ownerVerificationdetails.controls.phoneNumber.setValue(
        this.secureStorageService.getKeyData(localStorageKeys.ownerDetails).phoneNumber);
        this.selectedCountryISO = this.getCountryCodeByDialCode(this.secureStorageService.getKeyData(localStorageKeys.ownerDetails).countryPhoneCode);
      this.ownerVerificationdetails.controls.countryPhoneCode.setValue(
        (this.secureStorageService.getKeyData(localStorageKeys.ownerDetails).countryPhoneCode)?.toString(), { onlySelf: true });
        this.ownerVerificationdetails.controls.name.setValue(this.customerDetail.customerName);
        this.ownerVerificationdetails.controls.name.setValue(this.secureStorageService.getKeyData(localStorageKeys.ownerDetails).name);
        this.ownerVerificationdetails.controls.postcode.setValue(this.secureStorageService.getKeyData(localStorageKeys.ownerDetails).postcode);
        this.ownerVerificationdetails.controls.city.setValue(this.secureStorageService.getKeyData(localStorageKeys.ownerDetails).city);
        this.ownerVerificationdetails.controls.country.setValue(this.secureStorageService.getKeyData(localStorageKeys.ownerDetails).country);
        this.ownerVerificationdetails.controls.address1.setValue(this.secureStorageService.getKeyData(localStorageKeys.ownerDetails).address1);
        this.ownerVerificationdetails.controls.address2.setValue(this.secureStorageService.getKeyData(localStorageKeys.ownerDetails).address2);
    } else {
      this.ownerVerificationdetails.controls.email.setValue(this.customerDetail.customerEmailId);
        this.ownerVerificationdetails.controls.name.setValue(this.customerDetail.customerName);
        this.ownerVerificationdetails.controls.postcode.setValue(this.customerDetail.pinCode);
        this.ownerVerificationdetails.controls.phoneNumber.setValue(this.customerDetail.customerMobileNumber);
        this.selectedCountryISO = this.getCountryCodeByDialCode(this.customerDetail.dialCode);
      this.ownerVerificationdetails.controls.city.setValue(this.customerDetail.city);
      this.ownerVerificationdetails.controls.country.setValue(this.customerDetail.country);
      this.ownerVerificationdetails.controls.address1.setValue(this.customerDetail.addressLine1);
      this.ownerVerificationdetails.controls.address2.setValue(this.customerDetail.addressLine2);
      this.ownerVerificationdetails.controls.countryPhoneCode.setValue((this.customerDetail.dialCode)?.toString(), { onlySelf: true });
    }
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode.toString());
    return country ? country.countryCode : null;
  }

  mobileNumberChanged(){
    this.ownerVerificationdetails.controls.phoneNumber.setValue(this.ownerVerificationdetails.controls.phoneNumber?.value?.number ? this.ownerVerificationdetails.controls.phoneNumber?.value?.number.toString().replace(/\s+/g, '') : this.ownerVerificationdetails.controls.phoneNumber?.value);
  }

  public isNumber(event) {
    this.utilityService.isNumber(event);
  }


}
